import { Control, FieldValues, useController, UseControllerProps } from 'react-hook-form';
import FieldWrapper, { FieldWrapperProps } from 'shared/ui/form/fields/field-wrapper';

export interface CheckboxFieldProps<T extends FieldValues>
  extends UseControllerProps<T>,
    Omit<FieldWrapperProps, 'children'> {
  control?: Control<T>;
  labelRight?: string;
  disabled?: boolean;
  className?: string;
}

export const CheckboxField = <T extends FieldValues>({
  label,
  required,
  showError,
  labelRight,
  disabled,
  className,
  ...props
}: CheckboxFieldProps<T>) => {
  const {
    field,
    fieldState: { error }
  } = useController({
    ...props
  });

  return (
    <FieldWrapper label={label} error={error} required={required} showError={showError}>
      <div className={`form-check ${className || ''}`}>
        <input
          id={String(props.name)}
          className="form-check-input"
          type="checkbox"
          checked={!!field.value}
          onChange={(e) => field.onChange(e.target.checked)}
          onBlur={field.onBlur}
          ref={field.ref}
          disabled={disabled}
        />
        {labelRight && (
          <label className="form-check-label" htmlFor={String(props.name)}>
            {labelRight}
          </label>
        )}
      </div>
    </FieldWrapper>
  );
};
